import { useState } from 'react';
import { TextArea } from 'sharedUi/TextArea';
import FormField from './form-field';

/** A JSON object editor that only reports up when the text actually parses. */
export function JsonField({ label, value, onChange, hint, className }: {
  label: string;
  value: unknown;
  onChange: (o: Record<string, unknown> | undefined) => void;
  hint?: string;
  className?: string;
}) {
  const [text, setText] = useState(() => {
    const v = value as Record<string, unknown> | undefined;
    return v && Object.keys(v).length ? JSON.stringify(v, null, 2) : '';
  });
  const [error, setError] = useState('');

  const apply = (t: string) => {
    setText(t);
    if (!t.trim()) { setError(''); onChange(undefined); return; }
    try {
      const parsed = JSON.parse(t);
      if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
        setError('Must be a JSON object.');
        return;
      }
      setError('');
      onChange(parsed as Record<string, unknown>);
    } catch {
      setError('Invalid JSON.');
    }
  };

  return (
    <FormField label={label} error={error} hint={hint} className={className}>
      <TextArea
        rows={3}
        value={text}
        onChange={apply}
        error={error}
        placeholder="{ }"
        className="w-full font-mono text-xs"
      />
    </FormField>
  );
}
